import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M21.82,15.47a.7.7,0,0,0,0-.94l-3.66-4.19a1,1,0,0,0-1.4-.09,1,1,0,0,0-.08,1.41l2,2.34H11.39A1.39,1.39,0,0,0,10,15.39V18a1,1,0,0,0,1,1,1,1,0,0,0,1-1V16h6.72l-2,2.34A1,1,0,0,0,17.42,20a1,1,0,0,0,.74-.34Z"/><path d="M16,4h0L28,16,16,28,4,16,16,4h0m0-2a2,2,0,0,0-1.4.58l-12,12a2,2,0,0,0,0,2.8l12,12a2,2,0,0,0,2.8,0l12-12a2,2,0,0,0,0-2.8l-12-12A2,2,0,0,0,16,2Z"/>';
export var DrivingDirectionsOutlineSVG = function DrivingDirectionsOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
DrivingDirectionsOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(DrivingDirectionsOutlineSVG);